import axios from "axios";
import { zendeskApiKey, zendeskSupportKey } from "@/config";

async function request(
  method,
  url,
  data,
  isAgent = false,
  contentType = "application/json"
) {
  try {
    const response = await axios({
      method,
      baseURL: "https://inkit.zendesk.com",
      url,
      contentType,
      headers: {
        Authorization: `Basic ${isAgent ? zendeskApiKey : zendeskSupportKey}`,
        "Content-Type": contentType
      },
      data
    });

    return response.data;
  } catch (e) {
    // catch weird CORS error from zendesk side
    if (typeof e === "object" && e.message === "Network Error") {
      await Promise.resolve("Network Passed");
      return;
    }

    await Promise.reject(e);
  }
}

async function get(url, contentType) {
  return request("GET", url, contentType);
}

async function post(url, data, isAgent, contentType) {
  return request("POST", url, data, isAgent, contentType);
}

async function put(url, data, isAgent, contentType) {
  return request("PUT", url, data, isAgent, contentType);
}

async function del(url, data, contentType) {
  return request("DELETE", url, data, contentType);
}

// functions to export
export async function createTicket(data) {
  return post("/api/v2/tickets.json", {
    ...data
  });
}

export async function createRequest(data) {
  return post("/api/v2/requests.json", {
    ...data
  });
}

export async function updateRequest(id, data) {
  return put(`/api/v2/requests/${id}.json`, data, true);
}

export async function uploadAttachments(data) {
  let arrTokens = [];
  for (const item of data) {
    let zenhubResponse = await post(
      `/api/v2/uploads.json?filename=${item.name}`,
      item.file,
      true,
      "application/binary"
    );
    arrTokens.push({
      name: zenhubResponse.upload.attachments[0].file_name,
      token: zenhubResponse.upload.token
    });
  }

  return arrTokens;

  // return await post(`/api/v2/uploads.json?filename=${data[0].name}`, data[0].file, "application/binary");
}

export async function deleteAttachment(token) {
  await del(`/api/v2/uploads/${token}.json`);
}
